import React from 'react';

/**
 * Unified admin tab / pill-group. Same look across Settings, Invoices,
 * Messages, Bookings, Analytics, Calendar, Content, etc.
 *
 * <AdminTabs
 *   options={[{ id: 'unpaid', label: 'Unpaid', icon: Receipt, count: 3 }]}
 *   value={active}
 *   onChange={setActive}
 *   testid="admin-invoices-status-filter"
 * />
 */
export const AdminTabs = ({
  options = [],
  value,
  onChange,
  testid,
  optionTestid,
  size = 'md', // 'sm' | 'md'
  variant = 'accent', // 'accent' | 'danger'
  className = '',
  scrollable = true,
}) => {
  const pad = size === 'sm' ? 'px-2.5 py-1 text-[11px]' : 'px-3 py-1.5 text-xs';
  const activeClass = variant === 'danger'
    ? 'bg-red-500 text-white font-semibold'
    : 'bg-[var(--pg-admin-accent)] text-[var(--pg-admin-accent-fg)] font-semibold';

  return (
    <div
      data-testid={testid}
      className={`inline-flex rounded-xl border border-white/10 bg-[#141414] p-1 ${scrollable ? 'overflow-x-auto max-w-full' : ''} ${className}`}
    >
      {options.map((opt) => {
        const active = value === opt.id;
        return (
          <button
            key={opt.id}
            type="button"
            data-testid={opt.testid || (optionTestid ? optionTestid(opt.id) : undefined)}
            onClick={() => onChange?.(opt.id)}
            className={`inline-flex items-center gap-1.5 rounded-lg whitespace-nowrap transition-colors ${pad} ${active ? activeClass : 'text-white/70 hover:text-white'}`}
          >
            {opt.icon && <opt.icon className="w-3.5 h-3.5" />}
            <span>{opt.label}</span>
            {typeof opt.count === 'number' && opt.count > 0 && (
              <span className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-semibold ${active ? 'bg-black/15 text-current' : 'bg-white/10 text-white/70'}`}>
                {opt.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default AdminTabs;
